import makeRequest from 'api/';

export const signIn = async (params) => {
  return await makeRequest({
    method: 'post',
    url: '/auth/token',
    params,
  });
};
